import { useCallback, useRef } from 'react'

interface UseChatInputFileParams {
  onFilesSelected?: (fileList: File[]) => void
  onAttachFromChats?: () => void
  onAttachmentRemove?: (id: string) => void
}

export interface UseChatInputFileReturn {
  fileInputRef: React.RefObject<HTMLInputElement | null>
  handleAttachFromComputer: () => void
  handleFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleAttachFromChats: () => void
  handleRemoveAttachment: (id: string) => void
  openFilePicker: () => void
}

export const useChatInputFile = ({
  onFilesSelected,
  onAttachFromChats,
  onAttachmentRemove,
}: UseChatInputFileParams): UseChatInputFileReturn => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleAttachFromComputer = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  const handleFileInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFileList = e.target.files
      if (!selectedFileList || selectedFileList.length === 0 || !onFilesSelected) return

      const fileList = Array.from(selectedFileList)
      onFilesSelected(fileList)

      e.target.value = ''
    },
    [onFilesSelected]
  )

  const handleAttachFromChats = useCallback(() => {
    onAttachFromChats?.()
  }, [onAttachFromChats])

  const handleRemoveAttachment = useCallback(
    (id: string) => {
      onAttachmentRemove?.(id)
    },
    [onAttachmentRemove]
  )

  const openFilePicker = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  return {
    fileInputRef,
    handleAttachFromComputer,
    handleFileInputChange,
    handleAttachFromChats,
    handleRemoveAttachment,
    openFilePicker,
  }
}
